import React from 'react'

import './cardFSD.css'

import {BsFileEarmarkCode} from 'react-icons/bs'
import {MdOutlineScreenShare} from 'react-icons/md'

export default function CardFSD({name,demo,code,picture,tags,description}) {
  return (
    <div className='CardFSD'>
      <h2 className='CardFSDTitle'>{name}</h2>
      <img src={picture} className="ProjectFSDImg" alt='ProjectFSDImg'/>
      <p className='CardFSDDiscription'>{description}</p>
      <div className='CardFSDTags'>
        {
          tags.map((tag,i) => (
            <span key={i} className='tagFSDText'>{tag}</span>
          ))
        }
      </div>
      <div className='CardFSDBtns'>
        <a href={demo} className='DemoFSDBtn'><MdOutlineScreenShare/></a>
        <a href={code} className='CodeFSDBtn'><BsFileEarmarkCode/></a>
      </div>
    </div>
  )
}
